module.exports = __webpack_public_path__ + "static/media/thenightly_app_download_image_3.0e651386.png";